export { Ng2FabSpeedDialModule } from './fabSpeedDial/fabSpeedDial.module';
export { FabToggleDirective, FabButtonDirective, FabSpeedDialComponent } from './fabSpeedDial/fabSpeedDial.component';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-fab-speed-dial/src/index.js
// module id = ./node_modules/ng2-fab-speed-dial/src/index.js
// module chunks = vendor